module.exports = __webpack_public_path__ + "static/media/face.df6b1e70.png";